module.exports = __webpack_public_path__ + "img/procedimentos.60528738.svg";